import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button } from "@material-ui/core";
import Header from "../elements/Header";
import { useHistory } from "react-router-dom";
import "./AuthForm.css";
import { UserContext } from "../context/UserContext";

function AuthForm(props) {
  const { setUser } = useContext(UserContext);

  const [serverErrorMessage, setServerErrorMessage] = useState();
  let history = useHistory();
  const initialValues = {
    username: "",
    email: "",
    password: "",
  };

  async function onSubmit(values) {
    const url = `${
      process.env.REACT_APP_CONNECTION_URL
    }/${props.title.toLowerCase()}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      const responseData = await response.json();

      if (!response.ok) {
        throw Error(responseData.message);
      } else {
        console.log(props.title);
        if (props.title === "Signup") {
          setServerErrorMessage("");
          history.push("/login");
        } else {
          setUser({
            user: responseData.user,
            token: responseData.token,
            username: responseData.username,
          });
          localStorage.setItem("userData", JSON.stringify(responseData));
          history.push("/");
        }
      }
    } catch (err) {
      console.log(err);
      if (err.message === "Failed to fetch") {
        setServerErrorMessage(
          "Could not connect to the server. Please try again later"
        );
      } else {
        setServerErrorMessage(err.message);
      }
    }
  }
  function validate(values) {
    let errors = {};
    if (props.title === "signup" && !values.username) {
      errors.username = "Field Required";
    }
    if (!values.email) {
      errors.email = "Field Required";
    }
    if (!values.password) {
      errors.password = "Field Required";
    }
    return errors;
  }
  return (
    <div className="centralcontent">
      <div className="centralcontent_centralcontainer">
        <Header title={props.title} />
        <div className="form">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={validate}
          >
            {(formik) => {
              return (
                <Form>
                  {serverErrorMessage && (
                    <div className="serverErrorMessage">
                      {serverErrorMessage}
                    </div>
                  )}
                  {props.title === "Signup" && (
                    <div className="form-control">
                      <Field
                        type="text"
                        name="username"
                        id="username"
                        placeholder="username"
                      />
                      <ErrorMessage name="username" component="p" />
                    </div>
                  )}
                  <div className="form-control">
                    <Field
                      type="text"
                      name="email"
                      id="email"
                      placeholder="email"
                    />
                    <ErrorMessage name="email" component="p" />
                  </div>
                  <div className="form-control">
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      placeholder="password"
                    />
                    <ErrorMessage name="password" component="p" />
                  </div>
                  <div className="shit">
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={
                        !(formik.isValid && formik.dirty) || formik.isSubmitting
                      }
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default AuthForm;
